<div class="modal-container-custom">
  <div class="modal-content-custom dcnStyle_1">
    <div class="modal-header">
      <button type="button" id="close-dcn-additional-data-modal" class="close" aria-label="Close"
        (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">Issuer Confirmation to IPA</h4>
    </div>
    <form autocomplete="off" [formGroup]="issuerConfirmationToIPAForm">
      <div class="modal-body">
        <small class="mb-3">Fill up the details below and Proceed to generate the document.</small>
        <div class="dark-section">
          <div class="row">
            <div class="col-md-12">
              <div class="compt-input">
                <label>Place</label>
                <div class="r-value-box">
                  <input type="text" id="isipa-place" formControlName="place"
                    class="form-control block-box">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="compt-input mt-2 mb-4">
                <label>Date</label>
                <div class="r-value-box">
                  <input [attr.value]="issuerConfirmationToIPAForm.get('document_date').value" id="document-date"
                    class="form-control block-box text-left pt-5" [outsideDays]="'collapsed'"
                    placeholder="Document Date" name="document-date" formControlName="document_date" ngbDatepicker
                    [minDate]="looDateObj" [maxDate]="issueValueDateObj" [markDisabled]="isWeekendAndHolidayDisabled"
                    #documentDate="ngbDatepicker" (click)="documentDate.toggle()" [readonly]="true" required>
                  <div class="input-group-append icons-calender">
                    <button class="btn" (click)="documentDate.toggle()" type="button" id="document-date-btn">
                      <i class="far-i fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <div class="error-text" *ngIf="issuerConfirmationToIPAForm.get('document_date').errors">
                  <small *ngIf="issuerConfirmationToIPAForm.get('document_date').errors.ngbDate">
                    <ng-container *ngIf="issuerConfirmationToIPAForm.get('document_date').errors.ngbDate.requiredBefore">
                      Date should be more than or equal to Letter Of Offer date : {{looDateFormatted}}.
                    </ng-container>
                    <ng-container *ngIf="issuerConfirmationToIPAForm.get('document_date').errors.ngbDate.requiredAfter">
                      Date should be less than or equal to Issue Value Date : {{issueValueDateFormatted}}.
                    </ng-container>
                  </small>
                  <small *ngIf="issuerConfirmationToIPAForm.get('document_date').errors.required">
                    Date is required for document generation.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer modal-footer-custom">
      <button type="button" id="cancel-dcn-additional-data-modal"
        class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
        (click)="activeModal.close()">Cancel</button>
      <button type="submit" id="generate-dcn-additional-data"
        class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
        (click)="postItoIpaAdditionalData(issuerConfirmationToIPAForm.value)">Generate</button>
    </div>
  </div>
</div>